import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Tilty from 'react-tilty';
import { Grid, Chip, IconButton, Skeleton, Tooltip, Avatar, Button } from '@mui/material';
import { ContentCopy, Check } from '@mui/icons-material';

function shortenAddress(addr = '') {
    return addr.length > 8 ? `${addr.slice(0, 4)}...${addr.slice(-4)}` : addr;
}


const specialPool = {
    type: 'special',
    title: "🛡️ Meme Coin Insurance, Powered by $OSCAR",
    description: "Moon or rug — you win either way protection if your other coins rug.",
    earnValueText: "Earn up to 5× Value in $OSCAR:",
    tiers: [
        { emoji: "🥇", label: "Top 50", multiplier: "5×" },
        { emoji: "🥈", label: "Next 100", multiplier: "4×" },
        { emoji: "🥉", label: "Next 350", multiplier: "3×" },
        { emoji: "✅", label: "Everyone else", multiplier: "2×" },
    ]
};


const PoolTitle = ({ title, address }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    return (
        <h4
            style={{
                fontSize: 18,
                marginBottom: 6,
                color: '#fff',
                textDecoration: isHovered ? 'underline' : 'none',
                cursor: 'pointer',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => window.open(`https://www.meteora.ag/dlmm/${address}`, '_blank')}
        >
            {title}
        </h4>
    );
};


const PoolSubtitle = ({ href, children }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{
                fontSize: 20,
                color: '#ccc',
                marginBottom: 12,
                display: 'inline-block',
                textDecoration: isHovered ? 'underline' : 'none',
                cursor: 'pointer',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
        </a>
    );
};


const PublicPoolCards = ({ pools, isLoading, CountdownTimer }) => {
    const navigate = useNavigate();

    const [copiedMint, setCopiedMint] = useState('');
    const [poolsData, setPoolsData] = useState(new Array(4).fill({}));
    const [isHovered, setIsHovered] = useState(false);


    const handleCopy = (address) => {
        navigator.clipboard.writeText(address);
        setCopiedMint(address);
        setTimeout(() => setCopiedMint(''), 2000);
    };

    useEffect(() => {
        const poolsToRender = isLoading ? new Array(3).fill({}) : [...pools];
        setPoolsData(poolsToRender);
    }, [pools, isLoading]);

    const handleRedirect = () => {
        navigate(`/presale/submit`);
    };



    return (
        <>
            {/* <Tilty
                max={2}
                perspective={800}
            >
                <h2 style={{ color: '#fff', fontSize: 26, margin: '0 0 30px', marginTop: 50 }}>COMMUNITY POOLS</h2>
            </Tilty> */}
            <div className={`row ${poolsData.length === 4 ? 'justify-content-center' : ''}`} style={{ maxWidth: 1440, margin: '0 auto' }}>
                {poolsData.map((pool, index) => (

                    pool.type == 'special' ? (
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 d-flex justify-content-center" key="special-card" style={{ marginBottom: 20 }}>

                            <Tilty max={8} perspective={800}>
                                <div
                                    className="special-card"
                                    style={{
                                        width: '100%',
                                        padding: 24,
                                        minHeight: 410,
                                        backgroundColor: '#1f1f1f',
                                        borderRadius: 20,
                                        overflow: 'hidden',
                                        position: 'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        animation: 'glowFlash 1.1s ease-in-out infinite alternate'

                                    }}
                                >
                                    <div
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            border: '3px solid transparent',
                                            borderRadius: 20,
                                            background: 'linear-gradient(135deg, rgba(255,255,255,0.1), rgba(255,255,0,0.25)) border-box',
                                            maskImage: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
                                            maskComposite: 'exclude',
                                            WebkitMaskComposite: 'destination-out',
                                            zIndex: 1,
                                        }}
                                    />

                                    <div style={{ position: 'relative', zIndex: 2 }}>
                                        <h4 style={{ fontSize: 18, marginBottom: 6, color: '#fff' }}>
                                            🛡️ Meme Coin Insurance, Powered by $OSCAR
                                        </h4>

                                        <div
                                            style={{
                                                width: '100%',
                                                height: 3,
                                                backgroundColor: '#efbc00',
                                                marginBottom: 16,
                                                borderRadius: 2,
                                                opacity: 0.9,
                                            }}
                                        />

                                        <p style={{ fontSize: 15, color: '#ccc', marginBottom: 10 }}>
                                            Dumpster Destiny: Trade your rugged meme tokens for a shot at redemption.
                                        </p>

                                        <p style={{ fontSize: 15, color: '#efbc00', fontWeight: 600, marginBottom: 16 }}>
                                            Burn meme coins. Earn up to 5× $OSCAR.
                                        </p>

                                        <div style={{ display: 'grid', rowGap: 8 }}>
                                            <div style={{ fontSize: 14, color: '#ddd' }}>
                                                🥇 <strong>Top 50 Burners</strong> → <span style={{ color: '#efbc00' }}>5×</span>
                                            </div>
                                            <div style={{ fontSize: 14, color: '#ddd' }}>
                                                🥈 <strong>Next 100</strong> → <span style={{ color: '#efbc00' }}>4×</span>
                                            </div>
                                            <div style={{ fontSize: 14, color: '#ddd' }}>
                                                🥉 <strong>Next 350</strong> → <span style={{ color: '#efbc00' }}>3×</span>
                                            </div>
                                            <div style={{ fontSize: 14, color: '#ddd' }}>
                                                ✅ <strong>All others</strong> → <span style={{ color: '#efbc00' }}>2×</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: 24, position: 'relative', zIndex: 2 }}>
                                        <p style={{ fontSize: 15, color: '#999' }}>
                                            Submit, burn, and rank. 🔥 Limited slots. No second chances.
                                        </p>
                                    </div>
                                </div>
                            </Tilty>
                        </div>


                    ) : (
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 d-flex justify-content-center" key={pool.pool_address || index} style={{ marginBottom: 20 }}>
                            <Tilty
                                max={8}
                                perspective={800}
                                style={{
                                    transform: 'perspective(800px)',
                                    '& .tilty-inner': {
                                        transform: 'scale(1.05)',
                                        transformStyle: 'preserve-3d',
                                    }
                                }}
                            >
                                <div
                                    style={{
                                        flex: 1,
                                        width: '100%',
                                        padding: 24,
                                        backgroundColor: '#1f1f1f',
                                        backdropFilter: 'blur(6px)',
                                        boxShadow: '0 2px 14px rgba(0,0,0,0.2)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        transition: 'transform 0.3s ease, background-color 0.3s ease',
                                        cursor: 'default',
                                        border: '2px solid',
                                        borderColor: '#5c4902',
                                        borderRadius: 15,
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                        e.currentTarget.style.backgroundColor = 'rgba(255, 236, 150, 0.11)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.backgroundColor = '#1f1f1f';
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <div>
                                            {isLoading ? (
                                                <Skeleton width={120} height={32} />
                                            ) : (
                                                <PoolTitle title={pool.title} address={pool.pool_address} />
                                            )}
                                        </div>

                                        <div style={{ textAlign: 'right' }}>
                                            {isLoading ? <Skeleton width={100} height={24} /> : <CountdownTimer targetDate={pool["end-date"]} fontSize={12} endTitle="Presale ended" title="Pool ends in:" />}
                                        </div>
                                    </div>

                                    <div style={{ height: 2, backgroundColor: '#749d1a', marginBottom: 16 }} />

                                    <div className="row" style={{ marginBottom: 16, alignItems: 'center' }}>
                                        <div className="col-12 col-md-8">
                                            {isLoading ? (
                                                <Skeleton width={220} height={28} />
                                            ) : pool.twitter ? (
                                                <PoolSubtitle href={pool.twitter}>
                                                    {pool.subTitle}
                                                </PoolSubtitle>
                                            ) : (
                                                <p style={{ fontSize: 14, color: '#ccc', marginBottom: 12 }}>
                                                    {pool.subTitle}
                                                </p>
                                            )}
                                        </div>

                                        <div className="col-12 col-md-4" style={{ textAlign: 'right' }}>
                                            {isLoading ? (
                                                <Skeleton width={90} height={32} variant="rectangular" sx={{ borderRadius: 2 }} />
                                            ) : (
                                                <a
                                                    href={pool.swap_url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        display: 'inline-block',
                                                        padding: '6px 14px',
                                                        backgroundColor: '#c79e08',
                                                        color: '#fff',
                                                        borderRadius: 20,
                                                        fontSize: 12,
                                                        fontWeight: 600,
                                                        border: 'none',
                                                        textDecoration: 'none',
                                                        transition: 'background-color 0.3s ease',
                                                    }}
                                                    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#749d1a')}
                                                    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#c79e08')}
                                                >
                                                    {pool.buttonTitle}
                                                </a>
                                            )}
                                        </div>

                                        {[{ icon: pool.token_x_icon, label: pool.reserve_x, mint: pool.mint_x }, { icon: pool.token_y_icon, label: pool.reserve_y, mint: pool.mint_y }].map((token, i) => (
                                            <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                                {isLoading ? (
                                                    <Skeleton variant="circular" width={32} height={32} sx={{ marginRight: 1 }} />
                                                ) : (
                                                    <Avatar src={token.icon} alt={token.label} sx={{ width: 32, height: 32, marginRight: 1 }} />
                                                )}
                                                {isLoading ? (
                                                    <Skeleton width={60} height={28} sx={{ marginRight: 2 }} />
                                                ) : (
                                                    <span style={{ fontSize: 16, marginRight: 8 }}>{token.label}</span>
                                                )}
                                                {isLoading ? (
                                                    <Skeleton width={140} height={28} />
                                                ) : (
                                                    <Chip
                                                        style={{ marginLeft: 10 }}
                                                        label={
                                                            <span style={{ fontSize: 14 }}>
                                                                {shortenAddress(token.mint)}{' '}
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => handleCopy(token.mint)}
                                                                    sx={{ color: '#ddd' }}
                                                                >
                                                                    {copiedMint === token.mint ? (
                                                                        <Check fontSize="small" />
                                                                    ) : (
                                                                        <ContentCopy fontSize="small" />
                                                                    )}
                                                                </IconButton>
                                                            </span>
                                                        }
                                                        size="small"
                                                        sx={{ bgcolor: '#333', color: '#fff' }}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>

                                    <Grid container spacing={2} style={{ marginBottom: 16, marginTop: 2 }}>
                                        <Grid item xs={12}>
                                            {isLoading ? (
                                                <Skeleton width={220} height={30} />
                                            ) : (
                                                <Chip
                                                    label={
                                                        <div style={{ fontSize: 16, color: '#ccc' }}>
                                                            <strong>Total Value Locked:</strong> <span style={{ fontWeight: 600, color: '#efbc00' }}> ${pool.tvl_usd}</span>
                                                        </div>
                                                    }
                                                />
                                            )}
                                        </Grid>
                                        <Grid item xs={12}>
                                            {isLoading ? (
                                                <Skeleton width={220} height={30} />
                                            ) : (
                                                <Chip
                                                    label={
                                                        <div style={{ fontSize: 16, color: '#ccc' }}>
                                                            <strong>Current Pool Price:</strong> {pool.price_label}
                                                        </div>
                                                    }
                                                />
                                            )}
                                        </Grid>
                                    </Grid>

                                    <div
                                        style={{
                                            position: 'relative',
                                            height: 48,
                                            backgroundColor: 'rgba(255, 255, 0, 0.15)',
                                            borderRadius: 30,
                                            overflow: 'hidden',
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '0 15px',
                                            fontSize: 14,
                                            fontWeight: 500,
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                height: '100%',
                                                width: `${Math.min(pool.current_progress || 0, 75)}%`,
                                                backgroundColor: '#efbc00',
                                                transition: 'width 0.3s ease-in-out',
                                                zIndex: 1,
                                            }}
                                        />
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: '75%',
                                                height: '100%',
                                                width: '25%',
                                                backgroundImage: 'repeating-linear-gradient(-45deg, #67d36d 0, #67d36d 3px, transparent 3px, transparent 7px)',
                                                backgroundSize: '100% 100%',
                                                opacity: 0.7,
                                                zIndex: 1,
                                            }}
                                        />
                                        <Tooltip
                                            title={
                                                isLoading ? '' : (
                                                    <div style={{ padding: 12 }}>
                                                        <div style={{ color: '#efbc00', fontSize: 14, fontWeight: 600 }}>{pool.name}</div>
                                                        <div style={{ color: '#ded6b7', fontSize: 14 }}>Progress: {pool.current_progress}%</div>
                                                        <div style={{ color: '#ded6b7', fontSize: 14 }}>{pool.reserve_x}: {pool.reserve_x_amount}</div>
                                                        <div style={{ color: '#ded6b7', fontSize: 14 }}>{pool.reserve_y}: {pool.reserve_y_amount}</div>
                                                        <div style={{ color: '#ded6b7', fontSize: 14 }}>Current Price: {pool.price_label}</div>
                                                    </div>
                                                )
                                            }
                                            arrow
                                            disableInteractive
                                            followCursor
                                            PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
                                            componentsProps={{ tooltip: { sx: { backgroundColor: '#0d260a', fontSize: 12 } } }}
                                        >
                                            <div style={{ flex: 3, zIndex: 2, color: (pool.progress || 0) > 15 ? '#000' : '#fff' }}>
                                                {isLoading ? <Skeleton width={40} height={24} /> : pool.progress_label}
                                            </div>
                                        </Tooltip>

                                        <Tooltip
                                            title={
                                                <div style={{ padding: 12 }}>
                                                    <div style={{ color: '#67d36d', fontSize: 14, fontWeight: 600 }}>25% Back to the Community</div>
                                                    <div style={{ color: '#ded6b7', fontSize: 12 }}>
                                                        Once this pool is fully filled, 25% of the base token raised will be distributed to the community as a reward.
                                                    </div>
                                                    <div style={{ color: '#ded6b7', fontSize: 12 }}>
                                                        Claiming is available to the designated community wallet.
                                                    </div>
                                                </div>
                                            }
                                            arrow
                                            followCursor
                                            PopperProps={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
                                            componentsProps={{ tooltip: { sx: { backgroundColor: '#0d260a', fontSize: 12 } } }}
                                        >
                                            {/* <div style={{ flex: 1, zIndex: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                               
                                            </div> */}
                                        </Tooltip>
                                    </div>
                                </div>
                            </Tilty>
                        </div >
                    )
                ))}
            </div >
        </>
    );

};

export default PublicPoolCards;

